// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PmiFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'benchmarkId': !exists(json, 'benchmarkId') ? undefined : json['benchmarkId'],
        'name': json['name'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'currency': json['currency'],
        'customId': json['customId'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}
export function PmiToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'benchmarkId': value.benchmarkId,
        'name': value.name,
        'cusip': value.cusip,
        'currency': value.currency,
        'customId': value.customId,
        'description': value.description,
    };
}
